import { useState } from "react";
import { FileDetails } from "@/types/types";
import { NotificationCard } from "./NotificationCard";
import Modal from "@/components/ui/Modal";
import HelpModal from "./HelpModal";
import MessageSend from "@/assets/icons/MessageSend.svg";
import ClockWaiting from "@/assets/icons/ClockWaiting.svg";
import { AlertCircle } from "lucide-react";
import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import { FileUploadSection } from "./FileUploadSectio";
import { FileDownloadSection } from "./FileDownloadSection";
import { useFileUpload } from "../hooks/useFileUpload";
import { ReceiveConfirmation } from "./ReceiveConfirmation";

interface ShippedProductViewProps {
  isHighValueProduct: boolean;
  invoice: FileDetails;
  isCreatorBuyingProduct: boolean;
  isDelayed: boolean;
  isDamagedByCreator: boolean;
  damagedWhileShipping: boolean;
  delayedDate: string;
  issueDetails: string;
  isOthersReasonArise: boolean;
  expected_delivery_date: Date;
  purchase_invoice: FileDetails;
}

const ShippingProductView = ({
  isHighValueProduct,
  invoice,
  isCreatorBuyingProduct,
  isDelayed,
  isOthersReasonArise,
  delayedDate,
  isDamagedByCreator,
  expected_delivery_date,
  damagedWhileShipping,
  issueDetails,
  purchase_invoice,
}: ShippedProductViewProps) => {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const { orderId, videoId } = useOrderVideoParams();
  const {
    file,
    setFile,
    loading,
    handleUploadReceiptProof,
    handleConfirmReceived,
  } = useFileUpload(orderId as string, videoId as string);
  console.log(expected_delivery_date);
  return (
    <div className="m-3">
      {/* Notifications */}
      {isOthersReasonArise && (
        <NotificationCard
          icon={<AlertCircle className="text-amber-500 size-4" />}
          title="Creator Notification"
          description={`Important update from the creator: ${issueDetails}`}
        />
      )}
      {isCreatorBuyingProduct && purchase_invoice && (
        <NotificationCard
          icon={<MessageSend />}
          title="Creator purchased the product!"
          description="Creator has purchased the product and shared the invoice."
          borderColor="border-green-400"
          bgColor="bg-green-50"
        />
      )}
      {isDelayed && !damagedWhileShipping && !isDamagedByCreator && (
        <NotificationCard
          icon={<MessageSend />}
          title="Client Notified About Delivery Delay"
          description="We've let the client know about the delay you reported. We appreciate your patience and understanding."
        />
      )}
      {(isDamagedByCreator || damagedWhileShipping) && (
        <NotificationCard
          icon={<ClockWaiting />}
          title="Client Notified of Product Damage"
          titleColor="#027143"
          description="We've let the client know about the damage to the product during shipping. We're now waiting for their decision on whether they can reship a replacement."
        />
      )}

      {/* Shipping invoice from client */}
      {invoice && (
        <div>
          <p className="text-[#475467] text-xs leading-5">
            Shipping invoice provided by client
          </p>
          <FileDownloadSection file={invoice} />
        </div>
      )}
      {/* File Upload Section */}
      {/* {!isCreatorBuyingProduct && !purchase_invoice && (
        <FileUploadSection
          invoice={invoice}
          onUpload={setFile}
          isHighValueProduct={isHighValueProduct}
          onHelpClick={() => setHelpModalOpen(true)}
          onSubmit={handleUploadReceiptProof}
          loading={loading}
          file={file}
        />
      )} */}
      <ReceiveConfirmation
        expected_delivery_date={expected_delivery_date}
        onConfirm={handleConfirmReceived}
        loading={loading}
      />
      {/* Help Modal */}
      <Modal
        isOpen={helpModalOpen}
        setOpen={setHelpModalOpen}
        padding="24px"
        width="420px"
      >
        <HelpModal
          expected_delivery_date={expected_delivery_date}
          isCreatorBuyingProduct={isCreatorBuyingProduct}
          onClose={() => setHelpModalOpen(false)}
        />
      </Modal>
    </div>
  );
};

export default ShippingProductView;
